import React, { useRef, useState } from 'react'
import { getUserColor } from '../../utils/color';

import { Doughnut } from 'react-chartjs-2';

const User = (props) => {
    const users = props.data;
    const [viewMode, setViewMode] = useState('count'); // 'count' or 'amount'

    const backgroundColor = () => {
        const backgroundcolor = [];
        for (let i = 0; i < users.length; i++) {
            const color = getUserColor(users[i].name);
            backgroundcolor.push(color.replace('hsl', 'hsla').replace(')', ', 0.5)'));
        }
        return backgroundcolor;
    }

    const rupiah = (number) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        }).format(number);
    }

    const getOrCreateLegendList = (chart, id) => {
        const legendContainer = document.getElementById(id);
        let listContainer = legendContainer.querySelector('ul');

        if (!listContainer) {
            listContainer = document.createElement('ul');
            listContainer.style.margin = 0;
            listContainer.style.padding = 0;

            legendContainer.appendChild(listContainer);
        }

        return listContainer;
    };

    const htmlLegendPlugin = {
        id: "htmlLegend",
        afterUpdate(chart, args, options) {
            const ul = getOrCreateLegendList(chart, options.containerID);

            // Remove old legend items
            while (ul.firstChild) {
                ul.firstChild.remove();
            }

            // Reuse the built-in legendItems generator
            const items = chart.options.plugins.legend.labels.generateLabels(chart);

            items.forEach(item => {
                const li = document.createElement('li');
                li.classList.add('is-clearfix')
                li.classList.add('is-clickable')

                li.onclick = () => {
                    const { type } = chart.config;
                    if (type === 'pie' || type === 'doughnut') {
                        // Pie and doughnut charts only have a single dataset and visibility is per item
                        chart.toggleDataVisibility(item.index);
                    } else {
                        chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                    }
                    chart.update();
                };

                // Color box
                const boxSpan = document.createElement('div');
                boxSpan.style.background = item.fillStyle;
                boxSpan.style.borderColor = item.strokeStyle;
                boxSpan.style.borderWidth = item.lineWidth + 'px';
                boxSpan.style.height = '20px';
                boxSpan.style.marginRight = '10px';
                boxSpan.style.width = '20px';
                boxSpan.classList.add('is-pulled-left')

                const label = users.find(user =>
                    user.name === item.text
                )

                // Skip if no matching user found
                if (!label) return;

                // Text
                const textContainer = document.createElement('div');
                textContainer.style.color = item.fontColor;
                textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
                textContainer.classList.add('is-pulled-left');

                const text = document.createTextNode(item.text);
                textContainer.appendChild(text);

                // Amount
                const amountContainer = document.createElement('div');
                amountContainer.style.color = item.fontColor;
                amountContainer.style.textDecoration = item.hidden ? 'line-through' : '';
                amountContainer.classList.add('is-pulled-right')

                const displayValue = viewMode === 'count'
                    ? `${label.count} item`
                    : rupiah(label.amount);
                const amount = document.createTextNode(displayValue);
                amountContainer.appendChild(amount);

                li.appendChild(boxSpan);
                li.appendChild(textContainer);
                li.appendChild(amountContainer);
                ul.appendChild(li);
            });
        }
    };

    return (
        <div className='card'>
            <header className='card-header'>
                <p className='card-header-title is-size-7'>Item Transaksi per Member</p>
                <div className='card-header-icon'>
                    <div className='buttons has-addons are-small'>
                        <button
                            className={`button ${viewMode === 'count' ? 'is-primary is-selected' : ''}`}
                            onClick={() => setViewMode('count')}
                        >
                            Item
                        </button>
                        <button
                            className={`button ${viewMode === 'amount' ? 'is-primary is-selected' : ''}`}
                            onClick={() => setViewMode('amount')}
                        >
                            Nominal
                        </button>
                    </div>
                </div>
            </header>
            <div className='card-content'>
                <Doughnut
                    data={{
                        labels: users.map((item) => item.name),
                        datasets: [
                            {
                                data: users.map((item) => viewMode === 'count' ? item.count : item.amount),
                                backgroundColor: backgroundColor(),
                            }
                        ]
                    }}
                    options={{
                        plugins: {
                            htmlLegend: {
                                containerID: 'legend-container-user',
                            },
                            legend: {
                                display: false
                            }
                        }
                    }}
                    redraw={true}
                    plugins={[htmlLegendPlugin]}
                />
                <div id='legend-container-user' className='mt-5'></div>
                <div className='mt-3'>
                    <p className='is-size-7 has-text-grey'>
                        {viewMode === 'count'
                            ? '* Item adalah total transaksi (debit + kredit) per member'
                            : '* Nominal adalah total pengeluaran (kredit) per member'
                        }
                    </p>
                </div>
            </div>
        </div>
    )
}

export default User